export interface IUnlockUserRequest {
  email: string;
}

export class UnlockUserRequest implements IUnlockUserRequest {
  email: string;
}
